import { render, staticRenderFns } from "./ButtonCarousel.vue?vue&type=template&id=45cdef44&scoped=true"
import script from "./ButtonCarousel.vue?vue&type=script&lang=js"
export * from "./ButtonCarousel.vue?vue&type=script&lang=js"
import style0 from "./ButtonCarousel.vue?vue&type=style&index=0&id=45cdef44&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cdef44",
  null
  
)

export default component.exports